import React from 'react'

import { Box } from 'widgets/Box'

import { FormError } from './styled'

interface FormErrorTypes {
  errors: string[] | string
}

export const FormErrors = ({ errors }: FormErrorTypes) => {
  let errorMessages = errors
  if (!errorMessages || !errorMessages.length) return null

  if (typeof errorMessages === 'string') {
    errorMessages = [errorMessages]
  }

  return (
    <Box padding='sm'>
      {errorMessages.map((error: string) => {
        return <FormError fontSize='sm'>{error}</FormError>
      })}
    </Box>
  )
}
